<template>
  <article class="results-article-main mb-0 lg:mb-6" :style="stickyPosition">
    <div class="lg:sticky lg:top-8">
      <h4 class="text-xl font-bold">{{ t('Results') }}</h4>
      <div class="pt-5">
        <div class="grid grid-cols-2 gap-[19px] md:grid-cols-3 lg:flex lg:flex-col">
          <results-square :number="imputedPaO2" :defaultUnit="t('mmHg')">
            {{ t('sa_imputed_po') }}
          </results-square>
          <results-square :number="sfRatio">
            {{ t('sa_sf') }}
          </results-square>
          <results-square
            :number="pfRatio"
            class="col-start-1 col-end-3 justify-center md:col-start-3"
            :singleLine="!isBreakpointGreaterOrEqualToMD"
          >
            {{ t('sa_imputed_pf') }}
          </results-square>
        </div>
      </div>
    </div>
  </article>
</template>

<script setup>
import ResultsSquare from '@/common/components/ResultsSquare.vue';
import { avoidDisplacementOfResults, isBreakpointGreaterOrEqualToMD } from '@/common/utils';
import { defineProps, onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps(['imputedPaO2', 'pfRatio', 'sfRatio']);

const stickyPosition = ref({
  bottom: '0px',
});

onMounted(() => {
  avoidDisplacementOfResults({ stickyPosition });
});

onBeforeUnmount(() => {
  stickyPosition.value = null;
});
</script>

<style lang="postcss" scoped>
.results-article-main {
  @apply bg-white z-[77777] rounded-t-2xl sticky mt-9 py-4 px-6 order-last md:col-start-1 md:col-end-5 lg:static lg:columns-1 lg:col-start-5 lg:-mt-[5.5rem] lg:col-end-6 lg:-order-none lg:rounded-none lg:bg-light-blue lg:py-0 lg:px-0;
}
</style>
